var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{key:"note",attrs:{"name":"notification","appear":""}},[(_vm.displayNotification)?_c('div',{staticClass:"app-notification",class:_vm.classObj},[_vm._v(_vm._s(_vm.notification.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }